import { render, staticRenderFns } from "./MoniAdd.vue?vue&type=template&id=12181539&scoped=true"
import script from "./MoniAdd.vue?vue&type=script&lang=js"
export * from "./MoniAdd.vue?vue&type=script&lang=js"
import style0 from "./MoniAdd.vue?vue&type=style&index=0&id=12181539&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12181539",
  null
  
)

export default component.exports